// Sprint SICUREZZA-AMBITO — specchio lato interfaccia della regola unica del backend (permissions.py):
// lo sviluppatore vede tutto; ogni altro ruolo legge solo la matrice; una riga vale solo con "visualizza";
// "*" e righe senza azienda non valgono nulla; i permessi sommano (nessuna riga nega).
export const ruoloDi = (user) => user?.role_default || (user?.role || "").toLowerCase();

export const isDev = (user) => !!user && user.is_active !== false && ruoloDi(user) === "developer";

export const righeValide = (user) =>
  !user || user.is_active === false ? [] :
    (user.permissions_company_site || []).filter((r) => r.visualizza && r.company_id && r.company_id !== "*");

// Senza azienda: basta una riga qualsiasi della matrice; con l'azienda: le righe che coprono quella sede.
export function haFlag(user, flag, companyId, siteId) {
  if (isDev(user)) return true;
  return righeValide(user).some((r) => {
    if (companyId !== undefined && r.company_id !== companyId) return false;
    if (companyId !== undefined && siteId && r.site_id && r.site_id !== siteId) return false;
    return !!r[flag];
  });
}

export function ruoloGestione(user, ...companyIds) {
  if (isDev(user)) return true;
  if (ruoloDi(user) !== "admin" || user?.is_active === false) return false;
  const mie = new Set(righeValide(user).map((r) => r.company_id));
  return companyIds.every((c) => mie.has(c));
}

// Sprint CRM-5 — Impostazioni: «sistema = ruolo, azienda = matrice». Passaggio di proprietà: admin dell'azienda
// oppure casella «gestione_config_passaggio» su quell'azienda (specchio di passaggio_config_api._can_write)
export const FLAG_PASSAGGIO = "gestione_config_passaggio";
export const puoPassaggio = (user, cid) => ruoloGestione(user, cid) || haFlag(user, FLAG_PASSAGGIO, cid);
export const vedeImpostazioni = (user) => isDev(user) || (ruoloDi(user) === "admin" && user?.is_active !== false) || haFlag(user, FLAG_PASSAGGIO);

// Sprint CRM-1 — specchio della regola D di permissions.py (crm_vede_menu)
export const CRM_FLAGS = ["crm_gestisci_pipeline", "crm_gestisci_fasi", "crm_gestisci_elenchi", "crm_elimina_opportunita"];
// Sprint CRM-6 — quattro caselle delle note (specchio di permissions.CRM_FLAGS_NOTE), assenti = spente
export const CRM_FLAGS_NOTE = ["crm_modifica_note_proprie", "crm_elimina_note_proprie", "crm_modifica_note_altrui", "crm_elimina_note_altrui"];
// Sprint CRM-2B — casella sulla riga azienda × sede, assente = spenta
export const FLAG_AGENDE = "calendario_agende_colleghi";
export const FLAG_SEDE_ALTRUI = "calendario_gestisci_sede_altrui";  // Sprint CRM-2C
export const FLAG_ELIMINA_TODO = "calendario_elimina_todo";  // Sprint CAL-1
export function vedeMenuCrm(user, livelli) {
  if (isDev(user)) return true;
  if (Object.values(livelli || {}).some((l) => l && l !== "nessuno")) return true;
  return righeValide(user).some((r) => CRM_FLAGS.some((f) => r[f]));
}

// Sprint CRM-2A.1 — specchio di crm_vede_sede_opportunita (permissions.py): «tutte le sedi» = basta una sede dell'azienda
export const sediVisibili = (user, cid, sedi) => (isDev(user) ? sedi : sedi.filter((s) => righeValide(user).some(
  (r) => r.company_id === cid && (!r.site_id || r.site_id === s.id))));
export const vedeSedeOpportunita = (user, o) => isDev(user) || righeValide(user).some((r) => r.company_id === o.company_id
  && (o.tutte_le_sedi === true || !r.site_id || r.site_id === o.site_id));
